import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import BaseModal from "./BaseModal";
import { useAuth } from "../../context/AuthContext";

export default function SettingsModal({ onClose, source }) {
  const { i18n, t } = useTranslation();
  const { user } = useAuth();
  const currentLanguage = i18n.language === "ru" || i18n.language === "uz_latin" ? i18n.language : "uz_cyrl";

  const languages = [
    { code: "uz_latin", label: t("settings.languages.uzLatin") },
    { code: "uz_cyrl", label: t("settings.languages.uzCyrl") },
    { code: "ru", label: t("settings.languages.ru") },
  ];

  return (
    <BaseModal
      title={t("settings.title")}
      onClose={onClose}
      maxWidthClass="max-w-xl"
    >
      <div className="space-y-10 py-2">
        {/* Til sozlamalari */}
        <div className="space-y-5">
          <div className="flex items-center gap-3 px-1">
            <div className="h-8 w-8 rounded-lg bg-emerald-50 dark:bg-emerald-900/20 flex items-center justify-center text-[#1e9f6b]">
              <span className="material-symbols-outlined text-[18px]">language</span>
            </div>
            <label className="text-xs font-black text-slate-500 dark:text-slate-400 uppercase tracking-[0.2em]">
              {t("settings.language")}
            </label>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  i18n.changeLanguage(lang.code);
                  localStorage.setItem("app_language", lang.code);
                }}
                className={`flex flex-col items-center justify-center gap-2 p-5 rounded-2xl border-2 transition-all duration-300 ${
                  currentLanguage === lang.code 
                    ? 'border-[#1e9f6b] bg-[#1e9f6b]/5 dark:bg-[#1e9f6b]/10' 
                    : 'border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900/50 hover:border-slate-200 dark:hover:border-slate-700'
                }`}
              >
                <span className={`text-sm font-black italic tracking-tight ${
                  currentLanguage === lang.code ? 'text-[#1e9f6b]' : 'text-slate-600 dark:text-slate-400'
                }`}>
                  {lang.label}
                </span>
                {currentLanguage === lang.code && (
                  <motion.div layoutId="active-lang" className="h-1.5 w-1.5 rounded-full bg-[#1e9f6b]" />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Profil ma'lumotlari (qisqacha) */}
        <div className="p-6 bg-slate-50 dark:bg-slate-800/40 rounded-[28px] border border-slate-100 dark:border-slate-800/50 flex items-center justify-between group">
          <div className="flex items-center gap-4">
            <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-[#1e9f6b] to-[#0d7a52] flex items-center justify-center text-white text-lg font-black italic shadow-xl shadow-[#1e9f6b]/20 overflow-hidden">
              {user?.avatarUrl || user?.avatarDataUrl ? (
                <img src={user.avatarUrl || user.avatarDataUrl} className="h-full w-full object-cover" alt="Avatar" />
              ) : (
                user?.firstName?.[0]
              )}
            </div>
            <div>
              <p className="font-black text-slate-900 dark:text-white italic uppercase tracking-tight">{user?.fullName}</p>
              <p className="text-xs font-bold text-slate-500 mt-1 tracking-wide">{user?.phone}</p>
            </div>
          </div>
          <button 
            onClick={onClose} 
            className="h-12 px-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-xs font-black text-[#1e9f6b] uppercase tracking-widest hover:bg-[#1e9f6b] hover:text-white hover:border-[#1e9f6b] transition-all shadow-sm active:scale-95"
          >
            {t("common.done")}
          </button>
        </div>
      </div>
    </BaseModal>
  );
}


